export const UTP = [
  {
    title: 'Узнаете оптимальную цену',
    imageClass: 'coin',
    toolTipText: 'Анализируем рынок и\u00A0выстраиваем стратегию, чтобы продать квартиру выгодно',
  },
  {
    title: `Найдёте покупателя в\u00A0нужные сроки`,
    imageClass: 'key',
    toolTipText: 'Подключаем бесплатное продвижение объявления, чтобы получить максимум откликов',
  },
  {
    title: 'Проведёте сделку безопасно',
    imageClass: 'shield',
    toolTipText: 'Берём на себя юридические вопросы и сопровождаем на сделке',
  },
];
